// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoHero_videoContainer__GXqyz","videoPlayer":"VideoHero_videoPlayer__v0v4H","content":"VideoHero_content__yk2ZE"};